<template>
  <!-- 角色管理 -->
  <div class="menuManagement">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col :span="6"></el-col>
      <el-button type="primary" size="small" @click="operatInfo(1)">添加</el-button>
    </el-row>
    <el-table
        :data="tableList"
        tooltip-effect="dark"
        border
        ref="elTable"
        style="width: 100%;"
        :header-cell-style="$store.getters.getTableHeadStyle"
        v-loading="tableIsLoad"
        element-loading-text="加载中"
        row-key="menuId"
        :tree-props="{ children: 'children' }"
        :height="$store.getters.getTableHeight + 20"
    >
      <el-table-column
          prop="menuName"
          label="菜单名称 "
          align="left"
      ></el-table-column>
      <el-table-column label="菜单类型 " align="center">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.menuType == 0
                  ? "一级菜单"
                  : scope.row.menuType == 1
                  ? "二级菜单"
                  : "按钮"
            }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
          prop="url"
          label="模块地址 "
          align="center"
      ></el-table-column>
      <el-table-column
          prop="perms"
          label="授权标识 "
          align="center"
      ></el-table-column>
      <el-table-column
          prop="orderNum"
          label="排序 "
          width="100px"
          align="center"
      ></el-table-column>

      <el-table-column label="状态 " width="100px" align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.status == 0 ? "无效" : "有效" }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
              type="text"
              class="tableContentUpdateBut"
              @click="operatInfo(2, scope.row)"
          >修改</el-button
          >
          <span class="marSpan">|</span>
          <el-button
              type="text"
              class="tableContentRemoveBut"
              @click="operatInfo(0, scope.row)"
          >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
        custom-class="dailogComponents"
        :title="visibleType == 1 ? '添加' : '修改'"
        :visible.sync="visible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        v-if="visible"
        width="800px"
    >
      <div class="dialogBox">

        <el-row type="flex" class="dialogTitle" justify="left">
          <el-col :span="3">
            <p><span style="color:red;">*</span>菜单类型:</p>
          </el-col>
          <el-col :offset="1" :span="9">
            <el-radio-group @change="radioChange" v-model="visibleObj.menuType">
              <el-radio :label="0">一级菜单</el-radio>
              <el-radio :label="1">二级菜单</el-radio>
              <el-radio :label="2">按钮</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="left">
          <el-col :span="3">
            <p>
            <span style="color:red;">*</span
            >{{ visibleObj.menuType == 2 ? "按钮名称" : "菜单名称" }}:
            </p>
          </el-col>
          <el-col :offset="1" :span="7">
            <el-input
                v-model="visibleObj.menuName"
                placeholder="请输入"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <p><span style="color:red;">*</span>上级菜单:</p>
          </el-col>
          <el-col :offset="1" :span="7">
            <el-select v-model="visibleObj.parentId" placeholder="请选择" filterable>
              <el-option
                  v-for="item in getParentMenu"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="left">
          <el-col :span="3">
            <p><span style="color:red;">*</span>排序号:</p>
          </el-col>
          <el-col :offset="1" :span="7">
            <el-input-number
                v-model="visibleObj.orderNum"
                controls-position="right"
                :min="1"
            ></el-input-number>
          </el-col>
          <el-col :span="3">
            <p><span style="color:red;">*</span>状态:</p>
          </el-col>
          <el-col :offset="1" :span="9">
            <el-radio-group v-model="visibleObj.status">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="left">
          <el-col :span="3">
            <p>授权标识:</p>
          </el-col>
          <el-col :offset="1" :span="7">
            <el-input
                v-model="visibleObj.perms"
                placeholder="请输入菜单名称"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <p>模块URL:</p>
          </el-col>
          <el-col :offset="1" :span="7">
            <el-input
                v-model="visibleObj.url"
                placeholder="请输入上级菜单"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="submit"
            >确认</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    // RoleInfo,
  },
  data() {
    return {
      tableList: [],
      tableIsLoad: true,
      menuList: [],
      menuList2: [],
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        menuType: 0, //菜单类型
        menuName: "", //菜单名称
        orderNum: 1, //排序
        parentId: 0, //父菜单ID,一级菜单上级菜单为0
        perms: "", //授权标识
        status: 1, //状态
        url: "", //url
      },
    };
  },
  mounted() {
    this.tableLoad();
    this.getMenuListByType();
  },
  computed: {
    getParentMenu() {
      if (this.visibleObj.menuType == 0) {
        //一级菜单menulist
        this.visibleObj.parentId = 0;
        return [{ value: 0, label: "顶级菜单" }];
      } else if (this.visibleObj.menuType == 1) {
        //二级菜单menulist
        return this.menuList;
      } else {
        return this.menuList2;
      }
    },
  },
  methods: {
    tableLoad() {
      this.$axios.get("/menu/tree/list").then((res) => {
        this.tableList = res.data.data;
        this.tableIsLoad=false;
      });
    },
    getMenuListByType() {
      this.$axios.get("/menu/select/1").then((res) => {
        this.menuList = res.data.data;
      });
      this.$axios.get("/menu/select/2").then((res) => {
        this.menuList2 = res.data.data;
      });
    },
    operatInfo(type, row) {
      this.visibleType = type;
      this.visibleObj = {
        menuType: 0, //菜单类型
        menuName: "", //菜单名称
        orderNum: 1, //排序
        parentId: 0, //父菜单ID,一级菜单上级菜单为0
        perms: "", //授权标识
        status: 1, //状态
        url: "", //url
      };
      if (type === 0) {
        //删除
        this.$dailog({
          title: "删除",
          context: "是否删除所选内容?",
          callbackFun: () => {
            this.$axios.delete("/menu/" + row.menuId).then((res) => {
              this.$message({ type: "success", message: '操作成功!' ,duration:1000});
              this.tableLoad();
            });
          },
        });
      } else if (type === 1) {
        //添加
        this.visible = true;
      } else {
        //修改
        this.visible = true;
        this.visibleObj = row;
      }
    },
    submit() {
      let { menuName, parentId } = this.visibleObj;
      if (menuName === "" || parentId === "") {
        this.$message({ type: "warning", message: "必填项不能为空!",duration:1000 });
        return;
      }
      let subType = this.visibleType === 1 ? "post" : "put";
      this.$axios({
        method: subType,
        url: "/menu",
        data: this.visibleObj,
      }).then((res) => {
        this.$message({ type: "success", message: '保存成功!' ,duration:1000});
        this.visible = false;
        this.tableLoad();
      });
    },
    radioChange() {
      this.visibleObj.parentId = this.getParentMenu[0]
          ? this.getParentMenu[0].value
          : "";
    },
  },
};
</script>
<style lang="scss" scoped>
.menuManagement {
  .dialogTitle {
    margin-bottom: 10px;
    p {
      line-height: 260%;
      text-align: right;
    }
    .el-radio-group {
      label {
        margin-top: 10px;
      }
    }
  }
  .marSpan {
    margin: 0px 5px;
  }
}
</style>
<style lang="scss">
.menuManagement {
  .el-table__expand-icon {
    width: 35px !important;
  }
  .el-table__row--level-0{
    background-color: rgb(249,249,249);
  }
}
</style>
